import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#016E99",
    },
    secondary: {
      main: "#F56960",
    },
    background: {
      default: "#f9f9f9", // Background color
      paper: "#ffffff", // Surface color
    },
    text: {
      primary: "#000000", // Main text color
      secondary: "#555555", // Secondary text color
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Arial', sans-serif",
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 600,
      color: "#101F46",
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.6,
    },
    button: {
      textTransform: "none", // Prevent capitalization of button text
    },
  },
});

export default theme;
